/**
 * 시그널 램프 — 설비 경광등(적·황·녹)에서 가져온 상태 표시. 화면 전체에서 상태는 이 램프로만 말한다.
 * run: 가동/온라인, warn: 의도적 중지·대기, fault: 이상, off: 꺼짐/오프라인(불이 꺼진 램프).
 */
export type LampState = 'run' | 'warn' | 'fault' | 'off'

const LAMP_COLOR: Record<LampState, string> = {
  run: 'text-lamp-run',
  warn: 'text-lamp-warn',
  fault: 'text-lamp-fault',
  off: 'text-lamp-off',
}

export function Lamp({ state, className = '' }: { state: LampState; className?: string }) {
  return <span aria-hidden className={`lamp ${state === 'off' ? '' : 'lamp-lit'} ${LAMP_COLOR[state]} ${className}`} />
}

/** 램프 + 글자 — 배지 대신 쓰는 상태 표기 */
export function LampLabel({ state, children }: { state: LampState; children: React.ReactNode }) {
  return (
    <span className={`inline-flex items-center gap-2 text-xs font-medium ${state === 'off' ? 'text-gray-500' : 'text-gray-700'}`}>
      <Lamp state={state} />
      {children}
    </span>
  )
}

/** 경광등 모양 브랜드 마크 — 적·황·녹 세 칸 */
export function StackMark({ className = '' }: { className?: string }) {
  return (
    <span aria-hidden className={`inline-flex flex-col gap-[3px] rounded-[3px] bg-[#2a3033] p-[3px] ring-1 ring-black/10 dark:ring-white/10 ${className}`}>
      <span className="block h-[5px] w-[9px] rounded-[1px] bg-lamp-fault" />
      <span className="block h-[5px] w-[9px] rounded-[1px] bg-lamp-warn" />
      <span className="block h-[5px] w-[9px] rounded-[1px] bg-lamp-run" />
    </span>
  )
}
